<template>
	<div class="container">
		<Header />
		<Main />
		<Footer />
	</div>
</template>

<script>
import Header from '@/layout/Header.vue';
import Footer from '@/layout/Footer.vue';
import Main from '@/layout/Main.vue';

export default {
	data() {
		return {

		}
	},
	components: {
		Header,
		Footer,
		Main,
	},
	created() {

	},
	methods: {

	}
}
</script>
<style>

</style>
<style lang="less" scoped>
.container {
	width: 100%;
	max-width: 100% !important;
	min-height: calc(100vh - 144px);
	background: #f5f5f5;
}
</style>
